import React from 'react';
import { useAuth } from '../../contexts/AuthContext';

const ViewProfilePictureModal = ({ onClose, onReplace, onDelete, isDeleting }) => {
  const { user } = useAuth();

  const getProfileImageUrl = () => {
    if (user?.profile_picture) {
      return `/api/profile-picture/${user.profile_picture}`;
    }
    return '/unset-profile-pic.png';
  };

  const hasCustomPicture = !!user?.profile_picture;

  return (
    <div className="view-profile-modal">
      <div className="view-profile-modal__backdrop" onClick={onClose}></div>
      <div className="view-profile-modal__container">
        <div className="view-profile-modal__header">
          <h2>Profile Picture</h2>
          <button 
            className="view-profile-modal__close-btn"
            onClick={onClose}
            disabled={isDeleting}
          >
            ✕
          </button>
        </div>

        <div className="view-profile-modal__content">
          <div className="view-profile-modal__image-container">
            <img
              src={getProfileImageUrl()}
              alt={user?.username || 'Profile'}
              className="view-profile-modal__image"
              onError={(e) => {
                e.target.src = '/unset-profile-pic.png';
              }}
            />
          </div>
        </div>

        <div className="view-profile-modal__actions">
          <button
            className="view-profile-modal__btn view-profile-modal__btn--replace"
            onClick={onReplace}
            disabled={isDeleting}
          >
            Replace
          </button>
          
          {hasCustomPicture && (
            <button
              className="view-profile-modal__btn view-profile-modal__btn--delete"
              onClick={onDelete}
              disabled={isDeleting}
            >
              {isDeleting ? 'Deleting...' : 'Delete'}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default ViewProfilePictureModal;